import AbstractModel from './abstract-model';

export default abstract class AbstractGenLex extends AbstractModel {}
export abstract class GenLexWithLibelle extends AbstractGenLex {
  id: number;
  libelle: string;
}

export abstract class GenLexWithLabel extends AbstractGenLex {
  id: number;
  label: string;
}